import React, { Component } from 'react';
import DashboardAjuda from './DashboardAjuda';

// Card de indicador do Dashboard — sempre `surface-card` (tema-aware, acompanha claro/escuro do
// PrimeReact) por baixo, nunca uma cor de fundo fixa. Espelho de
// hay-hotspot/assets/reactweb/src/pages/Auth/Dashboard/DashboardStatCard.js.
class DashboardStatCard extends Component {
  render() {
    const { icone, titulo, valor, subtitulo, cor, help } = this.props;
    const corClasse = cor || 'blue';

    return (
      <div className="surface-card shadow-2 border-round p-3 h-full flex align-items-center gap-3">
        <div
          className={`flex align-items-center justify-content-center border-circle bg-${corClasse}-50 text-${corClasse}-500 flex-shrink-0`}
          style={{ width: '3rem', height: '3rem' }}
        >
          <i className={`pi ${icone}`} style={{ fontSize: '1.4rem' }} />
        </div>
        <div>
          <div className="text-2xl font-bold line-height-2">{valor}</div>
          <div className="text-color-secondary text-sm">
            {titulo}
            {subtitulo ? <span className="ml-1">({subtitulo})</span> : null}
            <DashboardAjuda texto={help} />
          </div>
        </div>
      </div>
    );
  }
}

export default DashboardStatCard;
